import { Controller } from "@hotwired/stimulus"

// Highlights the rail link whose section is currently in view.
export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)
      if (visible[0]) this.setActive(visible[0].target.id)
    }, { rootMargin: "-30% 0px -55% 0px", threshold: [0, 0.25, 0.5, 0.75, 1] })

    document.querySelectorAll("section[id]").forEach(s => this.observer.observe(s))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  setActive(id) {
    this.linkTargets.forEach(a => {
      const active = a.dataset.target === id
      a.classList.toggle("nav-active", active)
      a.classList.toggle("text-br-navy", active)
      a.classList.toggle("font-medium", active)
      a.classList.toggle("text-br-gray", !active)
    })
  }
}
